import { List, Space, Typography } from 'antd';
import { Fragment } from 'react';
import rfsTheme from '../../../theme';
import ShiftWarningTeamButton from './ShiftWarningTeamButton';
import type { ShiftFatigueViolation } from './types';

const { Text } = Typography;

type FatigueViolationDetailsProps = {
  readonly title: string;
  readonly violations: readonly ShiftFatigueViolation[];
};

/**
 * Displays the fatigue violation details, i.e. reason, date, team and role.
 */
const FatigueViolationDetails = ({
  title,
  violations,
}: FatigueViolationDetailsProps) => (
  <List
    bordered
    size="small"
    header={
      <Text strong style={{ color: rfsTheme.darkRfsRed }}>
        {title}
      </Text>
    }
    dataSource={[...violations]}
    renderItem={(violation) => (
      <List.Item>
        <Space direction="vertical">
          <Text strong>{violation.shiftDate}</Text>
          {violation.shifts.map((shift) => (
            <Fragment key={`${title}-${shift.id}`}>
              <Text>
                <Text strong>{shift.teamRoleName ?? ''}</Text> &nbsp;
                {shift.team?.id === undefined ? (
                  <></>
                ) : (
                  <ShiftWarningTeamButton team={shift.team} />
                )}
              </Text>
            </Fragment>
          ))}
        </Space>
      </List.Item>
    )}
  />
);

export default FatigueViolationDetails;
